import React from 'react';
import Typography from '@material-ui/core/Typography';
import ReturnToSiteButton from '../../components/returnToSiteButton';
import ThankYouSVG from '../../assets/images/thx.svg';
import { videoWrapperStyles } from '../../components/cameraPreview/styles';

import { useTranslation } from 'react-i18next';
import {Box} from "@material-ui/core";

export default function ThankYou() {
  const { t } = useTranslation(['app']);

  const classes = videoWrapperStyles();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="90vh">
      <img height={92} src={ThankYouSVG} alt={''} style={{ marginBottom: '24px' }} />
        <Typography variant="h3" gutterBottom align={'center'}>
            {t('app:thankYouTitle', 'Thank you')}
        </Typography>
        <Typography variant="h5" gutterBottom align={'center'}>
            {t('app:thankYouText', 'Thank you for finishing your verification. Our team will review your details and handle your verification as soon as possible.')}
        </Typography>
      <ReturnToSiteButton />
    </Box>
  );
}
